import { parseDateString } from 'utilities/dateUtilities';
import * as Yup from 'yup';

export const skyddsklassningFormSchema = Yup.object().shape({
  diarienummer: Yup.string()
    .required('Diarienummer måste anges')
    .max(50, 'Diarienumrets längd får vara max 50 tecken')
    .min(1, 'Diarienumrets längd får vara minst 1 tecken')
    .test('Digits and dash only', 'Diarienummer får endast innehålla siffror och bindestreck.', (value) =>
      value ? /^[0-9|-]{1,50}$/g.test(value) : true
    ),
  beslutsdatum: Yup.date()
    .transform(parseDateString)
    .typeError('Vänligen ange ett giltigt beslutsdatum')
    .required('Beslutsdatum måste anges')
    .max(new Date(), 'Datum får inte vara senare än dagens datum')
    .min('1900-01-01', 'År får inte vara tidigare än 1900')
});

export interface SkyddsklassningFormValues {
  diarienummer: string;
  beslutsdatum: Date | null;
}
